/**
 * Randomize a list of elements
 */
(function($) {
    $.fn.c24Randomize = function(childElem) {
        return this.each(function() {
            const $this = $(this);
            const elems = $this.children(childElem);
            elems.sort(function() { return (Math.round(Math.random()) - 0.5); });
            $this.detach(childElem);
            for (let i = 0; i < elems.length; i++) $this.append(elems[i]);
        });
    };
})(window.jQuery);
